'use client';
import * as z from 'zod/mini';
import { safeLocalStorageGetItem, safeLocalStorageSetItem } from '@//utils/safe-storage';

export const ItemHistoryItemSchema = z.object({
  id: z.string(),
  date: z.string().check(z.refine((val) => !Number.isNaN(Date.parse(val)), 'Invalid datetime')),
});

export type ItemHistoryItem = z.infer<typeof ItemHistoryItemSchema>;

export const ITEM_HISTORY_STORAGE_KEY = 'itemHistory';
export const ITEM_HISTORY_STORAGE_QUERY_KEY = [ITEM_HISTORY_STORAGE_KEY];

export const getItemHistory = (): ItemHistoryItem[] => {
  const raw = safeLocalStorageGetItem(ITEM_HISTORY_STORAGE_KEY);
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw);
    return z.array(ItemHistoryItemSchema).parse(arr);
  } catch {
    return [];
  }
};

export const setItemHistory = (history: ItemHistoryItem[]) => {
  safeLocalStorageSetItem(ITEM_HISTORY_STORAGE_KEY, JSON.stringify(history));
};
